module.exports = __webpack_public_path__ + "files/e7a4f51f7c845f140dd697b4479cd39e.png";